













import { Vue, Component, Prop } from 'vue-property-decorator';
import BusinessMenuDropdown from './BusinessMenuDropdown.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import eventBus from '@/utils/eventBus';

@Component({
  components: { BusinessMenuDropdown, Typography }
})
export default class BusinessMenuModal extends Vue {
  @Prop() businesses!: any;
  closing = false;

  get tPrefix() {
    return 'menus.sidebar.businessMenuDrop';
  }

  onClose() {
    this.closing = true;
    setTimeout(() => {
      eventBus.$emit('closeModal');
    }, 500);
  }
}
